export var InviteNextAction;
(function (InviteNextAction) {
    InviteNextAction["LOGIN"] = "LOGIN";
    InviteNextAction["ACCEPT_INVITE"] = "ACCEPT_INVITE";
    InviteNextAction["WAIT_APPROVAL"] = "WAIT_APPROVAL";
    InviteNextAction["GO_TO_APP"] = "GO_TO_APP";
    InviteNextAction["NONE"] = "NONE";
})(InviteNextAction || (InviteNextAction = {}));
//# sourceMappingURL=invite-next-action.enum.js.map